import React, { Component } from 'react'

import { ContentBlock } from 'components/ContentBlock'
import StatisticsData from './StatisticsData'

class StatisticsWrapper extends Component {
	state = {
		showStatistics: false
	}

	render({ children, statisticsData, showStatistics, switchLabel } = this.props) {
		let wrappedChildren
		// Check if exist real children components
		const showChildren = Array.isArray(children) ? children.some(child => typeof child === 'object') : children
		if(showChildren) {
			wrappedChildren = Array.isArray(children) ? children.map((child, i) => child ? <ContentBlock key={i}>{child}</ContentBlock> : null) : <ContentBlock>{children}</ContentBlock>
		}

		return(
			<React.Fragment>
				<StatisticsData toggling={showStatistics} label={switchLabel}>
					{this.props.statisticsData}
				</StatisticsData>
				{showChildren ? wrappedChildren : null}
			</React.Fragment>
		)
	}
}

export default StatisticsWrapper
